import { createContext, useContext } from 'react';

interface AssetRouteContextType {
  basePath: string;
  listPath: string;
  isWorkspaceMode: boolean;
  /**
   * The outer activity issue ID when `AssetCard` is rendered inside an
   * activities context (e.g. as the third column of `ActivityConversationPanel`).
   *
   * Components inside `AssetCard` that need the activity context — fold
   * components, media fold, etc. — should prefer this over `useParams().issueId`
   * because `useParams()` returns `{}` when the component is rendered outside
   * the `<Outlet>` that provides the child route context.
   */
  issueId?: string;
}

const AssetRouteContext = createContext<AssetRouteContextType | null>(null);

export const AssetRouteProvider = AssetRouteContext.Provider;

export const useAssetRouting = (assetId: string) => {
  const ctx = useContext(AssetRouteContext);
  return (
    ctx ?? {
      basePath: `/assets/${assetId}`,
      listPath: '/assets',
      isWorkspaceMode: false,
      issueId: undefined,
    }
  );
};
